import { SelectionChangedEvent } from "ag-grid-community";
import { EMPTY_COLLECTION_DTL_SEARCH_CRITERIA } from "domain/entity/Collection/CollectionDetailSearchCriteria";
import _ from "lodash";
import { CollectionConstant } from "presentation/constant/Collection/CollectionConstant";
import { INITIAL_COLLECTION_DTL_COL_DEF, INITIAL_COLLECTION_DTL_COL_DEF_OTHER, transferRowData } from "presentation/constant/Collection/CollectionDtlColumnDefinition";
import { WorkspaceConstant } from "presentation/constant/WorkSpaceConstant";
import { useCollectionVM } from "presentation/hook/Collection/useCollectionVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useCollectionTracked } from "presentation/store/Collection/CollectionProvider";
import { ConfirmModal } from "presentation/view/components/ConfirmModal";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import CollectionHeaderBar from "./CollectionHeaderBar";

const CollectionDtlTablePanel: React.FC = () => {

    const SCREEN_CONSTANT = CollectionConstant;
    const [collectionState] = useCollectionTracked();
    const collectionVM = useCollectionVM();
    const { collectionHdrList, collectionDtlList, isShowEditPanel, selectedDtlRows, selectedRows, totalInvAmt, searchCriteria } = collectionState;
    const gridRef: any = useRef(null);
    const messageBarVM = useMessageBarVM();
    const [isShowClose, setIsShowClose] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [anaInfoState] = useANAInfoTracked();
    const { operatingUnit } = anaInfoState;

    const handleAdd = useCallback(() => {
        collectionVM.onShowEditPanel(true).then(data => {
            if (data) {
                messageBarVM.showError(data);
                return;
            }
        });
    }, [collectionVM, messageBarVM])

    const handleEdit = useCallback(() => {
        if (selectedDtlRows.length !== 1) {
            messageBarVM.showError("Please select a record.");
            return;
        }
        collectionVM.onShowEditPanel(false);
    }, [collectionVM, messageBarVM, selectedDtlRows.length])

    const handleDelete = useCallback(async () => {
        if (_.isEmpty(selectedDtlRows)) {
            messageBarVM.showError("Please select a record.");
            return;
        }
        setIsLoading(true);
        let criteria = { ...EMPTY_COLLECTION_DTL_SEARCH_CRITERIA };
        const ids = selectedDtlRows.map(ety => ety.id);
        criteria = {
            ...criteria,
            selectRows: selectedRows,
            delDtlIds: ids,
            allRows: collectionHdrList
        }
        const hdrIds = selectedRows.map(ety => ety.id);
        await collectionVM.onDeleteCollectionDtl(criteria).then(data => {
            if (data && data.success) {
                // let criteria = { ...EMPTY_COLLECTION_DTL_SEARCH_CRITERIA };
                // criteria = {
                //     ...criteria,
                //     selectRows: selectedRows,
                //     allRows: collectionHdrList
                // }
                collectionVM.searchDtl(hdrIds).then(data => {
                    // collectionVM.onSearchDtl(criteria).then(data => {
                    setIsLoading(false);
                    messageBarVM.showSuccess("Delete Successfully.");
                });
                setIsLoading(false);
            } else {
                messageBarVM.showError(data.data ?? "Delete Failed.");
                setIsLoading(false);
                return;
            }
        });
    }, [collectionHdrList, collectionVM, messageBarVM, selectedDtlRows, selectedRows])

    const handClose = useCallback(async () => {
        //if (!isEditingHdr) {
        if ((operatingUnit === 'SAPT' || operatingUnit === 'KICT')) {
            const amt = collectionDtlList?.reduce((sum, item) => sum + (item.paymentAmount ?? 0), 0);
            if (collectionDtlList.length > 0 && totalInvAmt > amt) {
                setIsShowClose(true);
            } else {
                setIsLoading(true);
                if (collectionDtlList.length === 0) {
                    let criteria = { ...EMPTY_COLLECTION_DTL_SEARCH_CRITERIA };
                    criteria = {
                        ...criteria,
                        selectRows: selectedRows,
                        delDtlIds: [],
                        allRows: collectionHdrList,
                    }
                    await collectionVM.onleaveDtl(criteria).then(async data => {
                        collectionVM.onCloseClick();
                        await collectionVM.onSearch(searchCriteria).then(data => {
                            setIsLoading(false);
                        });
                        setIsLoading(false);
                    });
                    return;
                }
                collectionVM.onCloseClick();
                await collectionVM.onSearch(searchCriteria).then(data => {
                    setIsLoading(false);
                });
            }
        } else {
            collectionVM.onCloseClick();
            await collectionVM.onSearch(searchCriteria).then(data => {
                setIsLoading(false);
            });
        }
        //}
    }, [collectionDtlList, collectionHdrList, collectionVM, searchCriteria, selectedRows, totalInvAmt, operatingUnit])

    const handleClose = useCallback(() => {
        setIsShowClose(false);
        setIsLoading(true);
        let criteria = { ...EMPTY_COLLECTION_DTL_SEARCH_CRITERIA };
        const ids = collectionDtlList.map(ety => ety.id);
        criteria = {
            ...criteria,
            selectRows: selectedRows,
            delDtlIds: ids,
            allRows: collectionHdrList
        }
        collectionVM.onleaveDtl(criteria).then(async data => {
            collectionVM.onCloseClick();
            await collectionVM.onSearch(searchCriteria).then(data => {
                setIsLoading(false);
            });
            setIsLoading(false);
        });
    }, [collectionHdrList, collectionVM, searchCriteria, collectionDtlList, selectedRows])

    /*const handSave = useCallback(async () => {
        setIsLoading(true);
        let criteria = { ...EMPTY_COLLECTION_DTL_SEARCH_CRITERIA };
        criteria = {
            ...criteria,
            selectRows: selectedRows,
            allRows: collectionHdrList,
            observation: observation
        }
        await collectionVM.onApplyCollection(criteria).then(data => {
            setIsLoading(false);
        });
        collectionVM.onCloseClick();
    }, [collectionHdrList, collectionVM, observation, selectedRows])
    const handEditHeader = useCallback(() => {
        collectionVM.onEditHeaderCick();
    }, [collectionVM]);*/

    const handleCancel = useCallback(() => {
        setIsShowClose(false);
    }, [])

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        collectionVM.updateSelectedDtlRows(selectedRows);
    }, [collectionVM])

    const isPaymentModeLpaOrEdi = useCallback(() => {
        if (selectedDtlRows.some(entity => entity.paymentMode === 'LPA' || entity.paymentMode === 'BANK EDI')
            || selectedRows.some(entity => entity.receiptNo !== null && entity.receiptNo !== '' && entity.receiptNo !== undefined)) {
            return false;
        }
        return true;
    }, [selectedDtlRows, selectedRows])

    const memoBtns = useMemo(() => {

        const hdrBtns = [];
        if ((operatingUnit === 'SAPT' || operatingUnit === 'KICT') && !isShowEditPanel && isPaymentModeLpaOrEdi()) {
            hdrBtns.push({
                id: 'onEditButton',
                icon: 'Icon-pen',
                title: 'Edit'
            })
            hdrBtns.push({
                id: 'onDeleteButton',
                icon: 'Icon-trash',
                title: 'Delete'
            })
        }

        return hdrBtns
    }, [isPaymentModeLpaOrEdi, isShowEditPanel, operatingUnit])

    const isRowSelectable = useCallback((params: any) => {
        return !isShowEditPanel;
    }, [isShowEditPanel]);


    const memoTable = useMemo(() => {
        return (
            <NbisTable
                id='collection-dtl-table'
                isNewColumnSetting={true}
                columns={(operatingUnit === 'SAPT' || operatingUnit === 'KICT') ? INITIAL_COLLECTION_DTL_COL_DEF : INITIAL_COLLECTION_DTL_COL_DEF_OTHER}
                data={transferRowData(collectionDtlList ?? [])}
                showPaginator={false}
                editable={false}
                showAddIcon={(operatingUnit === 'SAPT' || operatingUnit === 'KICT') && !isShowEditPanel && isPaymentModeLpaOrEdi()}
                onAddClick={handleAdd}
                onEditButton={handleEdit}
                onDeleteButton={handleDelete}
                showDeleteButton={false}
                showReloadIcon={false}
                showUploadIcon={false}
                isScrollHighlighted={true}
                selectionMode={true}
                rowSelection={"multiple"}
                isRowHighligted={true}
                handleSelectionChanged={handleSelectionChange}
                // onRowDoubleClick={(e: any, entity: CollectionDetailEntity) => handleRowDoubleClick(entity)}
                gridHeight="customHeight"
                customHeight="calc(100vh - 250px)"
                ref={gridRef}
                headerActionButtons={memoBtns}
                handleRowSelectable={isRowSelectable}
            />
        );
    }, [collectionDtlList, handleAdd, handleDelete, handleEdit, handleSelectionChange, isPaymentModeLpaOrEdi, isRowSelectable, isShowEditPanel, memoBtns, operatingUnit])

    useEffect(() => {
        if (gridRef.current && gridRef.current.gridRef && gridRef.current.gridRef.current && gridRef.current.gridRef.current.api) {
            gridRef.current.gridRef.current.api.redrawRows();
        }
    }, [isShowEditPanel])

    return <>
        <div className="main-comp-wrapper">
            {/* <div style={{ height: (isShowEditPanel ? '35%' : '25%') }}> */}
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle></SidebarTitle>
                        <SidebarActionCross>
                            {/*(operatingUnit === 'SAPT' || operatingUnit === 'KICT') && (!isShowEditPanel && !isEditingHdr) && <IconButton
                                fileName="Icon-pen" size="medium" disabled={"FINALIZED" === currentRow.status} toolTipText='Edit' toolTipArrow={false} onClick={handEditHeader} />}
                            {(operatingUnit === 'SAPT' || operatingUnit === 'KICT') && (!isShowEditPanel && (isEditingHdr)) && <IconButton
                            fileName="Icon-tick" size="medium" toolTipText='Save' toolTipArrow={false} onClick={handSave} />*/}
                            {(!isShowEditPanel) && <IconButton
                                fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={handClose} />}
                        </SidebarActionCross>
                    </Sidebarheader>
                </div>
            </div>
            {/* </div> */}
            <CollectionHeaderBar />
            <TableWrapper>
                {isLoading &&
                    <Loader Indicator="Spinner" size="Medium" />}
                {memoTable}
                <ConfirmModal headerText={`${WorkspaceConstant.Common.BUTTON_CLOSE} ${SCREEN_CONSTANT.TITLE}`}
                    contentText={`${"Insufficient fund for settling the invoices."}\n${"All payment records will be cancelled.Quit anyway?"}`}
                    visible={isShowClose && (operatingUnit === 'SAPT' || operatingUnit === 'KICT')}
                    onCancelClick={handleCancel}
                    onConfirmClick={handleClose}
                />
            </TableWrapper>
        </div>
    </>;
}

export default memo(CollectionDtlTablePanel);
